import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import AdminApp from './components/AdminApp.jsx'
import AppToastProvider from './components/AppToastProvider.jsx'

// Initialize i18n before rendering
import './i18n';

// Initialize PostHog analytics
import { initPostHog } from './analytics/posthog';
initPostHog();

// Import CSS in the correct order as per README
import './styles/variables.css'
import './styles/global.css'
import './styles/layout.css'
import './styles/toast.css'
import './styles/pages/conversations.css'
import './styles/pages/widget-appearance.css'
import './styles/pages/broadcasts.css'
import './styles/pages/contacts.css'
import './styles/pages/segments.css'
import './styles/pages/pricing.css'
import './styles/pages/roles.css'
import './styles/pages/skills.css'
import './styles/skill-builder.css'
import './styles/pages/ai-tools.css'
import './styles/pages/integrations-detail.css'
// Responsive layout — imported LAST so its media-query rules win over the
// desktop defaults above (by source order) without needing !important.
import './styles/mobile.css'

// A DATA ROUTER, not <BrowserRouter> — one catch-all route whose element is
// the app exactly as before. AdminApp keeps its own <Routes> and every
// navigate() call site is untouched; descendant routes work the same under
// either router, and they share this router's history, so nothing about
// routing behaviour changes.
//
// The reason for the swap is useBlocker (hooks/useUnsavedChangesGuard.js),
// which warns before Settings or Profile are abandoned with edits in hand.
// It throws "useBlocker must be used within a data router" under
// <BrowserRouter>, and there is no equivalent for the component API. This is
// the smallest way to provide one: no loaders, no actions, no route objects
// to migrate — the alternative was hoisting AdminApp's ~40 routes out of the
// component, which would break every prop they close over.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AppToastProvider>
        <AdminApp />
      </AppToastProvider>
    ),
  },
])

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)